import { render, staticRenderFns } from "./Toggler.vue?vue&type=template&id=2b42c1cc&scoped=true&"
import script from "./Toggler.vue?vue&type=script&lang=js&"
export * from "./Toggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b42c1cc",
  null
  
)

export default component.exports